import SaveSolicitudPreventa from '../../shared/SaveSolicitudPreventa/SaveSolicitudPreventa'
export interface CreateResponsablev2Interface {}

const CreateSolicitudPreventa: React.FC<CreateResponsablev2Interface> = () => {
  return <SaveSolicitudPreventa titlePage="CREAR Solicitud" />;
};

export default CreateSolicitudPreventa;